// extracted by mini-css-extract-plugin
module.exports = {"main":"Nav_main__2MlMc","wrapper":"Nav_wrapper__zXuln","list":"Nav_list__tkcvn","link":"Nav_link__5hyRm","link__current":"Nav_link__current__4Agmw"};